import type { JssStyle } from 'jss';
import type { WebWidgetModel } from '@web/types';
import type { ChatBotWidgetData } from '@web/widgets/chat-bot/type/chat-bot-widget.type';

import {
    EButtonStyleType,
    EButtonType,
    EHorizontalPosition,
    EIconType,
    ESize,
    ESocialNetworks,
    Widgets,
} from '@common/enums';
import { defaultWidgetParams, defaultWidgetPermission } from '@common/constants';

import { ChatBotViewComponent } from '@web/widgets/chat-bot/components/chat-bot-view/chat-bot-view.component';
import { ChatBotControlComponent } from '@web/widgets/chat-bot/components/chat-bot-control/chat-bot-control.component';

import {
    DEFAULT_BUTTON_BASE,
    DEFAULT_BUTTON_HOVER_STATES,
} from '@web/widgets/common/base/base-button/base-button.const';

// DEFAULT COMPONENT SETTINGS
const chatBotData: ChatBotWidgetData = {
    chatBots: [
        {
            socialNetwork: ESocialNetworks.telegram,
            type: EButtonType.icon,
            iconType: EIconType.round,
            name: 'Telegram',
            link: '',
            description: '',
            botName: '',
            botId: '',
            variables: null,
            botChain: {
                chainId: null,
                name: '',
                isDefault: false,
            },
            uri: '',
            phone: '',
        },
    ],
    socialNetwork: ESocialNetworks.telegram,
    type: EButtonType.icon,
    iconType: EIconType.round,
    styleType: EButtonStyleType.secondary,
    horizontalAlign: EHorizontalPosition.L,
    mobileHorizontalAlign: EHorizontalPosition.L,
    tabletHorizontalAlign: EHorizontalPosition.L,
    height: 48,
    buttonSize: ESize.M,
    buttonBase: { ...DEFAULT_BUTTON_BASE },
    buttonHover: { ...DEFAULT_BUTTON_HOVER_STATES },
    isIndependentCorners: false,
    advancedRadius: {
        borderBottomLeftRadius: null,
        borderBottomRightRadius: null,
        borderTopLeftRadius: null,
        borderTopRightRadius: null,
    },
    advancedBorderSettings: null,
    isShadow: false,
    shadowSettings: null,
    isSynchronizeStyle: true,
    hideOnMobile: false,
    hideOnDesktop: false,
    hideOnTablet: false,
    position: {
        width: 100,

        x: 0,
        y: 0,
        rotate: 0,
        zIndex: 0,
        mobileX: 0,
        mobileY: 0,
        mobileRotate: 0,
        mobileZIndex: 0,
    },
};

const chatBotStyle: JssStyle = {};
// END DEFAULT SETTINGS

export const chatBotWidgetModel: WebWidgetModel = {
    componentView: ChatBotViewComponent,
    componentControl: ChatBotControlComponent,
    name: Widgets.CHAT_BOTS,
    label: 'widget_chat_bot_label',
    data: chatBotData,
    styles: chatBotStyle,
    permission: defaultWidgetPermission,
    params: { ...defaultWidgetParams, type: ['default', 'specific'] },
};
